/**
 * MockOR Form JSON.
 * @module src/util/FormJson/MockORWithLocation
 */
import { Form } from '../../components/Shared/FormEngine/FormEngine.types';

const MockORWithLocation: Form = [
  {
    kind: 'field',
    name: 'topInfo',
    fieldLabel: '*Required fields',
    fieldType: 'text',
    required: true,
    optionsAutoSelected: false,
    isShow: true,
    permissionSets: [],
    date: false,
    time: false,
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'salesRep',
        fieldLabel: 'Sales Rep',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'Sales Rep',
        optionsDynamic: 'getSalesReps',
        optionsDependentField: [],
        optionsAutoSelected: true,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'tbaAccount',
        fieldLabel: 'Account Types',
        fieldType: 'radio',
        isShow: true,
        required: false,
        optionsPlaceHolder: 'Account Types',
        optionsDynamic: 'getTbaAccounts',
        optionsDependentField: [],
        optionsStatic: [
          { value: 'My Accounts', label: 'My Accounts', id: 'My Accounts' },
          { value: 'TBA Accounts', label: 'TBA Accounts', id: 'TBA Accounts' },
        ],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'account',
        fieldLabel: 'Account',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'Account',
        optionsDynamic: 'getAccounts',
        optionsDependentField: ['salesRep'],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'startDate',
        fieldLabel: 'Start Date/Time',
        fieldType: 'dateTimePicker',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        permissionSets: [],
        date: true,
        time: true,
      },
      {
        kind: 'field',
        name: 'endDate',
        fieldLabel: 'End Date/Time',
        fieldType: 'dateTimePicker',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        permissionSets: [],
        date: true,
        time: true,
      },
      {
        kind: 'field',
        name: 'eventDescription',
        fieldLabel: 'Event Description',
        fieldType: 'textArea',
        isShow: true,
        required: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
        characterLimit: 32000,
      },
    ],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'coveringRep',
        fieldLabel: 'Covering Rep',
        fieldType: 'selectMultiDynamicPicker',
        required: false,
        isShow: true,
        optionsPlaceHolder: 'Covering Rep',
        optionsDynamic: 'getCoveringReps',
        optionsDependentField: ['salesRep'],
        // optionsDependentField: ['account'],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'eventLocation',
        fieldLabel: 'Event Location',
        fieldType: 'radio',
        required: false,
        isShow: true,
        optionsPlaceHolder: 'Event Location',
        optionsStatic: [
          {
            label: 'Ship To Address',
            value: 'Ship To Address',
            id: 'Ship To Address',
          },
          {
            label: 'Other Address',
            value: 'Other Address',
            id: 'Other Address',
          },
        ],
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'locationDescription',
        fieldLabel: 'Location Description',
        fieldType: 'textArea',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'street1',
        fieldLabel: 'Street 1',
        fieldType: 'textBox',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'street2',
        fieldLabel: 'Street 2',
        fieldType: 'textBox',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'country',
        fieldLabel: 'Country',
        // fieldType: 'selectSingleDynamicAutoCompletePicker',
        fieldType: 'input',
        required: false,
        isShow: true,
        optionsPlaceHolder: 'Country',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
        optionsStatic: [
          {
            label: 'US',
            value: 'US',
            id: 'US',
          },
        ],
      },

      {
        kind: 'field',
        name: 'city',
        fieldLabel: 'City',
        // fieldType: 'selectSingleDynamicAutoCompletePicker',
        fieldType: 'textBox',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'City',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'state',
        fieldLabel: 'State',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        // fieldType: 'textArea',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'State',
        optionsDynamic: 'getStates',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'opportunity',
        fieldLabel: 'Opportunity',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'Opportunity',
        optionsDynamic: 'getOpportunity',
        optionsDependentField: ['account'],
        optionsAutoSelected: true,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'zipCode',
        fieldLabel: 'Zip Code',
        // fieldType: 'selectSingleDynamicAutoCompletePicker',
        fieldType: 'textBox',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'Zip Code',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
        keypadType: 'default',
      },
      {
        kind: 'field',
        name: 'comments',
        fieldLabel: 'Comments',
        fieldType: 'comments',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        characterLimit: 32000,
        permissionSets: [],
      },
    ],
  },
];

/** Exporting MockOR form json */
export default MockORWithLocation;
